
<div class='selector'>
  <div class='selector-container'>
    <div class='selector-arrow selector-arrow_left' @click='prevRoom()'></div>
    <div class="selector-txt-container selector-txt-services">
      <div class='selector-ico'>
        <i class="el-icon-menu"></i>
      </div>
      <div id='serviceToPrint' class='selector-txt'>
        {{ getCurrentRoom }}
      </div>
      <el-select v-model="valueSelect" value-key="id" @change="setSelectedRoomLocal">
        <el-option v-for="item in getRooms" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class='selector-arrow selector-arrow_right' @click='nextRoom()'></div>
  </div>
</div>
